const getThemeFont = theme => {
  switch (theme) {
    case 'Pharma':
      return 'Roboto, sans-serif'
    case 'Getz':
      return 'Lato, sans-serif'
    case 'Moonshot':
      return 'Helvetica, sans-serif'
    case 'Trendsetter':
      return 'Helvetica, sans-serif'
    case 'Darknight':
      return 'Roboto, sans-serif'
    case 'Beauty':
      return 'Roboto,sans-serif'
    case 'Gifts':
      return 'var(--font-harmonia)'
    case 'Fresh':
      return 'ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji'
    case 'Quick':
      return 'var(--font-schibsted)'
    case 'Bazar':
      return 'var(--font-harmonia)'
    default:
      return 'Open-Sans, sans-serif'
  }
}

export default getThemeFont
